enum LayoutTypes {
    SM,
    MOBILE,
    TABLET,
    DESKTOP,
}

export default LayoutTypes;
